// This should only be used within the main app instance
import app from '../../main_app'
// References the $cookies instance bound to the current Vue instance
// This is a helper function for $cookies. This can be used within Vuex and/or any place outside of the component template or instance.
// Requires the current app instance defined in main.js
// Usage example: appCookies().set('CookieName', { ... })
export const appCookies = () => {
  return app.config.globalProperties.$cookies
}
